(() => {
  const header = document.querySelector('[data-gk-header]');
  if (!header) return;
  const root = document.documentElement;

  // Hauteur du header pour les éléments collants du thème (--header-height) et le menu mobile.
  const syncHeight = () => {
    const h = header.offsetHeight;
    root.style.setProperty('--header-height', h + 'px');
    root.style.setProperty('--gk-mheader', h + 'px');
  };
  new ResizeObserver(syncHeight).observe(header);

  // Barre d'annonces : rotation toutes les 5 s, flèches, pause au survol et au focus.
  const announce = header.querySelector('[data-gk-announce]');
  if (announce) {
    const msgs = [...announce.querySelectorAll('[data-gk-msg]')];
    let idx = 0;
    let timer = null;
    const show = (i) => {
      idx = (i + msgs.length) % msgs.length;
      msgs.forEach((m, n) => m.classList.toggle('is-active', n === idx));
    };
    const start = () => {
      stop();
      if (msgs.length > 1) timer = setInterval(() => show(idx + 1), 5000);
    };
    const stop = () => clearInterval(timer);
    announce.querySelector('[data-gk-prev]').addEventListener('click', () => show(idx - 1));
    announce.querySelector('[data-gk-next]').addEventListener('click', () => show(idx + 1));
    announce.addEventListener('mouseenter', stop);
    announce.addEventListener('mouseleave', start);
    announce.addEventListener('focusin', stop);
    announce.addEventListener('focusout', start);
    start();
  }

  // Version compacte : posée quand la sentinelle (60 premiers px de la page) sort de l'écran.
  const sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:60px;pointer-events:none;visibility:hidden;';
  document.body.prepend(sentinel);
  new IntersectionObserver(([entry]) => {
    header.classList.toggle('is-compact', !entry.isIntersecting);
  }).observe(sentinel);

  // Méga menu : l'ouverture est en CSS (:hover / :focus-within) ; ici seulement aria-expanded et Échap.
  header.querySelectorAll('[data-gk-item]').forEach((item) => {
    const link = item.querySelector(':scope > .gk-item__link');
    const sync = () => {
      const open = !item.classList.contains('is-closed') && (item.matches(':hover') || item.contains(document.activeElement));
      link.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    item.addEventListener('mouseenter', sync);
    item.addEventListener('mouseleave', () => {
      item.classList.remove('is-closed');
      requestAnimationFrame(sync);
    });
    item.addEventListener('focusin', sync);
    item.addEventListener('focusout', () => requestAnimationFrame(() => {
      if (!item.contains(document.activeElement)) item.classList.remove('is-closed');
      sync();
    }));
    item.addEventListener('keydown', (e) => {
      // Entrée sans lien (collection vide) : Entrée / Espace ouvrent ou ferment le panneau.
      if (e.target === link && link.tagName !== 'A' && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        item.classList.toggle('is-closed');
        sync();
        return;
      }
      if (e.key !== 'Escape') return;
      item.classList.add('is-closed');
      link.focus();
      sync();
    });
  });

  // Menu mobile : Échap ferme, libellé du burger à jour.
  const mobile = header.querySelector('[data-gk-mobile]');
  if (mobile) {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobile.open) {
        mobile.open = false;
        mobile.querySelector('summary').focus();
      }
    });
    const summary = mobile.querySelector('summary');
    const label = () => summary.setAttribute('aria-label', mobile.open ? summary.dataset.labelClose : summary.dataset.labelOpen);
    mobile.addEventListener('toggle', label);
    label();
  }

  // Recherche réduite à une loupe entre 990 et 1279 px : la loupe ouvre le champ sous la barre.
  const toggle = header.querySelector('[data-gk-search-toggle]');
  if (toggle) {
    const field = header.querySelector('.gk-search input[name="q"]');
    const setOpen = (open) => {
      header.classList.toggle('is-search-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) field?.focus();
    };
    toggle.addEventListener('click', () => setOpen(!header.classList.contains('is-search-open')));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && header.classList.contains('is-search-open')) { setOpen(false); toggle.focus(); }
    });
    document.addEventListener('click', (e) => {
      if (header.classList.contains('is-search-open') && !e.target.closest('.gk-search, [data-gk-search-toggle]')) setOpen(false);
    });
  }

  // Sélecteur langue et pays (desktop) : clic à l'extérieur, Échap ou ouverture d'un panneau du menu le referment.
  const lsel = header.querySelector('[data-gk-lsel]');
  if (lsel) {
    const close = (focus) => {
      if (!lsel.open) return;
      lsel.open = false;
      if (focus) lsel.querySelector('summary').focus();
    };
    document.addEventListener('click', (e) => { if (!lsel.contains(e.target)) close(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && lsel.contains(document.activeElement)) close(true); });
    lsel.addEventListener('focusout', () => requestAnimationFrame(() => { if (!lsel.contains(document.activeElement)) close(false); }));
    header.querySelectorAll('[data-gk-item]').forEach((item) => item.addEventListener('mouseenter', () => close(false)));
  }

  // Panier : si le tiroir existe, <cart-icon> l'ouvre ; on empêche alors la navigation vers /cart.
  header.querySelectorAll('[data-gk-cart-link]').forEach((a) => {
    a.addEventListener('click', (e) => {
      if (document.querySelector('[data-ref="cart-drawer"]')) e.preventDefault();
    });
  });
})();
